import { NgxsModuleOptions, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { ApplicationConfig } from './application.config';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';
import { ProductState } from '../../domain/product/store/product.state';
import { SubscriptionState } from '../../domain/subscription/store/subscription.state';
import { DistributorState } from '../../domain/distributor/store/distributor.state';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
  executionStrategy: NoopNgxsExecutionStrategy,
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: [],
};

export const ngxsStates = [
  ApplicationState,
  CacheDataState,
  ProductState,
  SubscriptionState,
  DistributorState
];
